import consumer from './consumer'

export const subscribeToCalendarChannel = ({ onUpdate }) => {
  consumer.subscriptions.create('CalendarsChannel', {
    initialized () {
      this.update = this.update.bind(this)
    },

    received (notification) {
      this.update(notification)
    },

    update (notification) {
      onUpdate(notification)
    },
  })
}
